import React from 'react';
import { useHistory } from 'react-router-dom';

interface HistoryListenerProps {
    alert: TODO_TYPEME;
}
export function HistoryListener({ alert }: HistoryListenerProps) {
    const history = useHistory();
    React.useEffect(() => {
        const unlisten = history.listen(() => {
            alert.advanceDismissOnChange();
        });

        return () => {
            unlisten();
        };
    }, [alert, history]);

    return null;
}
